import React, { useEffect, useState } from "react";
import CommonLayout from "../../../layouts/CommonLayout";
import { allAPiServicesCall } from "../../../services/apiServices";
import { getAuthConfig } from "../../../services/apiUtils";
import { useNavigate } from "react-router-dom";
import { ROUTE_CONSTANT } from "../../../routes/constant";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaShieldAlt,
  FaEdit,
  FaKey,
  FaCalendarAlt,
} from "react-icons/fa";

function ShowProfile() {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchUserData = async () => {
    setLoading(true);
    try {
      const response = await allAPiServicesCall.getProfileDetails(
        {},
        getAuthConfig(),
        navigate
      );
      if (response.success) {
        // Handle both plain object and Mongoose document (_doc)
        const rawData = response.data;
        const data = rawData._doc || rawData;
        setProfileData(data);
      }
    } catch (error) {
      console.log(error, ":error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const getRoleBadgeColor = (role) => {
    switch (role?.toLowerCase()) {
      case "superadmin":
        return "linear-gradient(135deg, #0031E2 0%, #1444F0 100%)";
      case "admin":
        return "linear-gradient(135deg, #1DB954 0%, #22c55e 100%)";
      default:
        return "linear-gradient(135deg, #0031E2 0%, #1444F0 100%)";
    }
  };

  const getInitials = (name) => {
    if (!name) return "AD";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const styles = {
    container: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)",
      padding: "40px 20px",
    },
    profileWrapper: {
      maxWidth: "900px",
      margin: "0 auto",
    },
    headerCard: {
      background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
      borderRadius: "24px",
      padding: "40px",
      marginBottom: "24px",
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
    },
    headerPattern: {
      position: "absolute",
      top: 0,
      right: 0,
      width: "300px",
      height: "300px",
      background:
        "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
      borderRadius: "50%",
      transform: "translate(30%, -30%)",
    },
    headerContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      position: "relative",
      zIndex: 1,
    },
    avatarContainer: {
      position: "relative",
      marginBottom: "20px",
    },
    avatar: {
      width: "140px",
      height: "140px",
      borderRadius: "50%",
      border: "4px solid rgba(255, 255, 255, 0.2)",
      objectFit: "cover",
      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.3)",
    },
    avatarPlaceholder: {
      width: "140px",
      height: "140px",
      borderRadius: "50%",
      background: "linear-gradient(135deg, #0031E2 0%, #1444F0 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "48px",
      fontWeight: "700",
      color: "white",
      border: "4px solid rgba(255, 255, 255, 0.2)",
      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.3)",
    },
    statusDot: {
      position: "absolute",
      bottom: "10px",
      right: "10px",
      width: "24px",
      height: "24px",
      background: "#22c55e",
      borderRadius: "50%",
      border: "4px solid #1a1a2e",
    },
    userName: {
      fontSize: "28px",
      fontWeight: "700",
      color: "white",
      margin: "0 0 8px 0",
      textAlign: "center",
    },
    userEmail: {
      fontSize: "16px",
      color: "rgba(255, 255, 255, 0.7)",
      margin: "0 0 16px 0",
    },
    roleBadge: {
      padding: "8px 24px",
      borderRadius: "50px",
      fontSize: "14px",
      fontWeight: "600",
      color: "white",
      textTransform: "uppercase",
      letterSpacing: "1px",
    },
    detailsCard: {
      background: "white",
      borderRadius: "20px",
      padding: "32px",
      marginBottom: "24px",
      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
    },
    sectionTitle: {
      fontSize: "20px",
      fontWeight: "700",
      color: "#1a1a2e",
      marginBottom: "24px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    sectionIcon: {
      width: "40px",
      height: "40px",
      background: "linear-gradient(135deg, #0031E2 0%, #1444F0 100%)",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
    },
    infoGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "20px",
    },
    infoItem: {
      display: "flex",
      alignItems: "center",
      padding: "20px",
      background: "#f8fafc",
      borderRadius: "16px",
      transition: "all 0.3s ease",
      border: "1px solid #e2e8f0",
    },
    infoIcon: {
      width: "48px",
      height: "48px",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "16px",
      fontSize: "20px",
    },
    infoContent: {
      flex: 1,
    },
    infoLabel: {
      fontSize: "13px",
      color: "#64748b",
      fontWeight: "500",
      marginBottom: "4px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    infoValue: {
      fontSize: "16px",
      color: "#1e293b",
      fontWeight: "600",
    },
    buttonGroup: {
      display: "flex",
      gap: "16px",
      flexWrap: "wrap",
    },
    button: {
      flex: "1",
      minWidth: "200px",
      padding: "16px 32px",
      borderRadius: "14px",
      fontSize: "16px",
      fontWeight: "600",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      transition: "all 0.3s ease",
    },
    primaryButton: {
      background: "linear-gradient(135deg, #0031E2 0%, #1444F0 100%)",
      color: "white",
      boxShadow: "0 10px 30px rgba(0, 49, 226, 0.4)",
    },
    secondaryButton: {
      background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
      color: "white",
      boxShadow: "0 10px 30px rgba(26, 26, 46, 0.3)",
    },
    loadingContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "60vh",
    },
    spinner: {
      width: "60px",
      height: "60px",
      border: "4px solid #e2e8f0",
      borderTopColor: "#0031E2",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    },
    loadingText: {
      marginTop: "20px",
      fontSize: "16px",
      color: "#64748b",
      fontWeight: "500",
    },
  };

  // Add keyframes for spinner animation
  const spinnerKeyframes = `
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `;

  if (loading) {
    return (
      <CommonLayout>
        <style>{spinnerKeyframes}</style>
        <div style={styles.container}>
          <div style={styles.loadingContainer}>
            <div style={styles.spinner}></div>
            <p style={styles.loadingText}>Loading profile...</p>
          </div>
        </div>
      </CommonLayout>
    );
  }

  return (
    <CommonLayout>
      <style>{spinnerKeyframes}</style>
      <div style={styles.container}>
        <div style={styles.profileWrapper}>
          {/* Header Card with Avatar */}
          <div style={styles.headerCard}>
            <div style={styles.headerPattern}></div>
            <div style={styles.headerContent}>
              <div style={styles.avatarContainer}>
                {profileData?.avatar ? (
                  <img
                    src={profileData.avatar}
                    alt="Profile"
                    style={styles.avatar}
                  />
                ) : (
                  <div style={styles.avatarPlaceholder}>
                    {getInitials(profileData?.fullName)}
                  </div>
                )}
                <div style={styles.statusDot}></div>
              </div>
              <h1 style={styles.userName}>
                {profileData?.fullName || "Admin User"}
              </h1>
              <p style={styles.userEmail}>
                {profileData?.email || "No email provided"}
              </p>
              <span
                style={{
                  ...styles.roleBadge,
                  background: getRoleBadgeColor(profileData?.role),
                }}
              >
                {profileData?.role || "Admin"}
              </span>
            </div>
          </div>

          {/* Details Card */}
          <div style={styles.detailsCard}>
            <div style={styles.sectionTitle}>
              <div style={styles.sectionIcon}>
                <FaUser />
              </div>
              Profile Information
            </div>

            <div style={styles.infoGrid}>
              <div
                style={styles.infoItem}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    ...styles.infoIcon,
                    background:
                      "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                    color: "white",
                  }}
                >
                  <FaUser />
                </div>
                <div style={styles.infoContent}>
                  <p style={styles.infoLabel}>Full Name</p>
                  <p style={styles.infoValue}>
                    {profileData?.fullName || "Not provided"}
                  </p>
                </div>
              </div>

              <div
                style={styles.infoItem}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    ...styles.infoIcon,
                    background:
                      "linear-gradient(135deg, #1DB954 0%, #17a34a 100%)",
                    color: "white",
                  }}
                >
                  <FaEnvelope />
                </div>
                <div style={styles.infoContent}>
                  <p style={styles.infoLabel}>Email Address</p>
                  <p style={styles.infoValue}>
                    {profileData?.email || "Not provided"}
                  </p>
                </div>
              </div>

              <div
                style={styles.infoItem}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    ...styles.infoIcon,
                    background:
                      "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                    color: "white",
                  }}
                >
                  <FaPhone />
                </div>
                <div style={styles.infoContent}>
                  <p style={styles.infoLabel}>Phone Number</p>
                  <p style={styles.infoValue}>
                    {profileData?.mobile || "Not provided"}
                  </p>
                </div>
              </div>

              <div
                style={styles.infoItem}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    ...styles.infoIcon,
                    background:
                      "linear-gradient(135deg, #0031E2 0%, #1444F0 100%)",
                    color: "white",
                  }}
                >
                  <FaShieldAlt />
                </div>
                <div style={styles.infoContent}>
                  <p style={styles.infoLabel}>Role</p>
                  <p
                    style={{
                      ...styles.infoValue,
                      textTransform: "capitalize",
                    }}
                  >
                    {profileData?.role || "Admin"}
                  </p>
                </div>
              </div>

              <div
                style={styles.infoItem}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    ...styles.infoIcon,
                    background:
                      "linear-gradient(135deg, #FF4163 0%, #e62e4f 100%)",
                    color: "white",
                  }}
                >
                  <FaCalendarAlt />
                </div>
                <div style={styles.infoContent}>
                  <p style={styles.infoLabel}>Account Status</p>
                  <p style={{ ...styles.infoValue, color: "#22c55e" }}>
                    Active
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={styles.buttonGroup}>
            <button
              style={{ ...styles.button, ...styles.primaryButton }}
              onClick={() => navigate(ROUTE_CONSTANT.AUTH.EDIT_PROFILE)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 15px 40px rgba(0, 49, 226, 0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 10px 30px rgba(0, 49, 226, 0.4)";
              }}
            >
              <FaEdit /> Edit Profile
            </button>
            <button
              style={{ ...styles.button, ...styles.secondaryButton }}
              onClick={() => navigate(ROUTE_CONSTANT.AUTH.CHANGE_PASSWORD)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 15px 40px rgba(26, 26, 46, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 10px 30px rgba(26, 26, 46, 0.3)";
              }}
            >
              <FaKey /> Change Password
            </button>
          </div>
        </div>
      </div>
    </CommonLayout>
  );
}

export default ShowProfile;
